export enum InvoiceType {
  Normal = 'normal',
  Rectification = 'rectification',
}
